import { render, staticRenderFns } from "./SfSidebar.vue?vue&type=template&id=32564821&"
import script from "./SfSidebar.vue?vue&type=script&lang=js&"
export * from "./SfSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SfSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports